import { DeliveryResolver } from "./DeliveryResolver";

export class QuomiDeliveryResolver extends DeliveryResolver {
  timeRangeEnabled = true;

  timeRanges = [
      {
          from: "09:00",
          to: "18:00",
          price: 0,
      },
  ];
}
